import styles from './index.scss'
import { Tabs } from 'antd-mobile'
import { useMemo, useState } from 'react'
import DpBusinessPopup from '@/libs/components/DpBusinessComponents/DpBusinessPopup'
import IconTitle from './iconTitle'

const DEFAULT_ICON_URL = 'https://oss-images.dragonpass.com.cn/business-saas/platform/2023-03-14_110846/temp'

const TRACKER_MODULE_NAME = '联系客服弹窗'
const TRACKER_COMPONENT_DIAL = '联系客服弹窗拨号'
const TRACKER_COMPONENT_CLOSE = '联系客服弹窗关闭'

// 客服信息
const CustomerService = (props: any) => {
  const [visible, updateVisible] = useState(false)
  const [activeKey, updateActiveKey] = useState('')
  // 平台
  const tels = useMemo(() => {
    return [{
      title: !props?.h5Setting?.businessServiceTels?.length ? '系统客服' : '平台客服',
      dataIndex: 'servicePhoneContent',
      hidden: !props?.h5Setting?.servicePhoneContent?.length
    }, {
      title: '商品客服',
      dataIndex: 'businessServiceTels',
      hidden: !props?.h5Setting?.businessServiceTels?.length
    }, {
      title: '联系客服',
      dataIndex: 'customerServiceTels',
      hidden: !props?.h5Setting?.customerServiceTels?.length
    }, {
      title: '联系客服', // 专属客服
      dataIndex: 'personalServiceTels',
      hidden: !props?.h5Setting?.personalServiceTels?.length
    }]?.filter(item => !item?.hidden)
  }, [props?.h5Setting])

  const isHasBusiness = !!props?.h5Setting?.businessServiceTels?.length
  const onSendClickTracker = (key: string) => {
    if (props?.trackerPermission?.includes(key)) {
      window?.dpTracker?.sendClk({
        eventData: {
          module_name: TRACKER_MODULE_NAME,
          component_name: TRACKER_COMPONENT_DIAL
        }
      })
    }
  }
  const renderTels = (data: any[] = []) => (
    <div className={styles['dp-business-toolbar-tels']} >
      {data?.map?.((item, index: number) => (
        <a
          className={styles['dp-business-toolbar-tels-item']}
          key={index}
          onClick={() => onSendClickTracker('customer')}
          href={`tel:${item.tel || item?.value}`}
        >
          {item.tel || item?.value} ({item?.name || item?.key})
        </a>
      ))}
    </div>
  )
  
  const useTels = useMemo(() => {
    return (props?.h5Setting?.[activeKey] || []).filter?.((item: { enable?: boolean }) => item?.enable === undefined || !!item?.enable)
  }, [activeKey, props?.h5Setting])

  return <>
    <IconTitle itemStyles={props?.itemStyles}
      onClick={() => {
        if (isHasBusiness) {
          updateActiveKey('businessServiceTels')
        } else {
          updateActiveKey(tels?.[0]?.dataIndex)
        }
        updateVisible(true)
        props?.onClick?.(activeKey)
      }}
      hiddenName={props?.hiddenName}
      title={props?.title || '客服'}
      src={props?.src || DEFAULT_ICON_URL}
    />
    <DpBusinessPopup
      visible={visible}
      onClose={() => {
        updateVisible(false)
        if (props?.trackerPermission?.includes('customer')) {
          window?.dpTracker?.sendClk?.({
            eventData: {
              module_name: TRACKER_MODULE_NAME,
              component_name: TRACKER_COMPONENT_CLOSE
            }
          })
        }
      }}
      title={
        tels?.length === 1 ? <div style={{ paddingTop: 12 }}>{tels?.[0]?.title}</div>
        :
        <Tabs
          className={styles['dp-business-toolbar-tabs']}
          defaultActiveKey={'99999999999'}
          activeKey={activeKey}
          onChange={(key) => updateActiveKey(key)}
          activeLineMode={'fixed'}
          style={{ '--fixed-active-line-width': '20px' }}
        >
          {
            tels?.map(item => <Tabs.Tab title={item?.title} key={item?.dataIndex} />)
          }
        </Tabs>
      }
      bodyStyle={{ zIndex: 999999, ...props?.customStyle }}
      headerStyle={{ textAlign: 'center', borderWidth: 0, padding: '8px 20px 16px', background: 'var(--content-bg-color, #ffffff)' }}
      popupBodyStyles={{
        height: useTels?.length * 78 + 76,
        minHeight: ( useTels?.length > 2 ? useTels?.length : 3) * 78 + 76,
        ...props?.customStyle,
      }}
      containerStyles={{
        padding: '0 20px 8px',
        ...props?.customStyle
      }}
      popupProps={{
        getContainer: () => document.body
      }}
    >
      <> {renderTels(useTels)} </>
    </DpBusinessPopup>
  </>
}
export default CustomerService
